import { render, staticRenderFns } from "./DonutConsultationsISTBySexe.vue?vue&type=template&id=054e0b88&"
import script from "./DonutConsultationsISTBySexe.vue?vue&type=script&lang=ts&"
export * from "./DonutConsultationsISTBySexe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports